export default "__VITE_ASSET__CcR1_9Hf__"